import { render } from "./TagCreateModal.vue?vue&type=template&id=3ee99680&ts=true"
import script from "./TagCreateModal.vue?vue&type=script&lang=ts"
export * from "./TagCreateModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__